module.exports = __webpack_public_path__ + "img/nokia-60x60.2c9d8a5b.png";